module.exports = __webpack_public_path__ + "static/media/0_2019_08_10.8e020bf4.jpg";